export enum DATA_QA {
  CANCEL = 'dnc-rename__cancel',
  CONFIRM = 'dnc-rename__confirm',
}
